import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import AppDetailReflection from "@/views/MGT/AppDetail/AppDetailCom/app-detail-reflection.vue";
import AppDetailPointModal from "@/views/MGT/AppDetail/AppDetailModal/app-detail-point-modal.vue";
import { roleBindingTree, saveRoleMappings } from "@/service/appList.js";
export default {
  name: "AppDetailTab6",
  components: {
    AppDetailReflection,
    AppDetailPointModal
  },
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      loading: false,
      activeValue: "PMS",
      treeData: [],
      retVal: {}
    };
  },
  computed: {
    // 第三方钉钉
    _isThirdDingDing() {
      return this.detail.appId === "ID_UPSTREAM_DING_TALK";
    },
    // 企业微信
    _isEnterpriseWechat() {
      return this.detail.appId === "ID_UPSTREAM_WECHAT_WORK_PRIVATE";
    },
    // 企业微信通讯录同步应用
    _isEnterpriseWechatSync() {
      return this.detail.appId === "ID_UPSTREAM_WECHAT_WORK_SYNC";
    },
    // opera
    _isOperaCloud() {
      return this.detail.appId === "ID_OPERA_CLOUD";
    },
    // 上游系统标识
    _upstream() {
      let value = "";
      if (this._isThirdDingDing) {
        value = "DING_TALK";
      } else if (this._isEnterpriseWechat || this._isEnterpriseWechatSync) {
        value = "WE_CHAT_WORK_PRIVATE";
      } else if (this._isOperaCloud) {
        value = "IWORK_UPSTREAM_MIRROR";
      }
      return value;
    },
    // 隐藏左侧菜单栏
    _hideMenu() {
      return this._isOperaCloud;
    },
    // 下游系统标识
    _downstream() {
      if (this._isOperaCloud) {
        return "OPERA_CLOUD";
      } else {
        return this.activeValue;
      }
    },
    // 组织结构左侧显示文案
    _leftTitle() {
      let value = "";
      if (this._isThirdDingDing) {
        value = $t("60jw6g7", "钉钉组织下角色");
      } else if (this._isEnterpriseWechat) {
        value = $t("gs08tg9", "企业微信组织下角色");
      } else if (this._isOperaCloud) {
        value = $t("7ayk1aa", "iWork组织下角色");
      }
      return value;
    },
    // 组织结构右侧显示文案
    _rightTitle() {
      let value = "";
      if (this._isThirdDingDing) {
        value = $t("gctiaa4", "绿云角色");
      } else if (this._isEnterpriseWechat) {
        value = $t("gctiaa4", "绿云角色");
      } else if (this._isOperaCloud) {
        value = $t("99r5umc", "OperaCloud角色");
      }
      return value;
    }
  },
  mounted() {
    this.getTree();
  },
  methods: {
    /*
     * 获取所有树
     */
    async getTree() {
      let params = {
        upstream: this._upstream,
        downstream: this._downstream
      };
      this.loading = true;
      let res = await roleBindingTree(params);
      this.loading = false;
      if (res.data && res.data.result == 0) {
        this.retVal = res.data.retVal;
        this.changeRetVal(res.data.retVal);
      } else {
        this.retVal = {};
        this.treeData = [];
      }
    },
    /*
     * 兼容组件数据处理
     */
    changeRetVal(retVal) {
      let tree = retVal.upstreamRoles;
      let change = (arr, father = null, level = 1) => {
        arr.forEach(v => {
          // 设置层级
          v.level = level;
          // 配置参数设置
          this.setParams(v, father);
          let children = v.children;
          if (children && children.length > 0) {
            change(children, v, level + 1);
          }
        });
      };
      change(tree);
      this.treeData = tree;
    },
    /*
     * 配置参数设置
     */
    setParams(v, father) {
      // 记录父级
      v.father = father;
      // 左边显示标题
      v.title = v.name;
      // 默认展开
      this.$set(v, "expand", true);
      // 右边是否显示关联功能
      v.bindVisible = v.level === 2 ? true : false;
      // 右边没有关联时候的标题
      v.bindTitle = $t("atapcx4", "关联角色");
      // 没有关联(downstreamRoles有数据为关联)
      v.noBind = v.downstreamRoles.length === 0;
      // 关联的名称
      v.bindName = v.downstreamRoles.map(v => {
        return v.roles.map(r => `${r.name} (${r.downstreamRoleCode})`).join(";");
      }).join(";");
    },
    /*
     * 解除关联
     */
    async onDeleteBind(data) {
      let params = {
        session: this.retVal.session,
        upstream: this._upstream,
        downstream: this._downstream,
        upstreamRoleId: data.upstreamRoleId,
        mappings: []
      };
      this.loading = true;
      let res = await saveRoleMappings(params);
      this.loading = false;
      if (res.data && res.data.result == 0) {
        this.$Message.success($t("jk1gy76", "解除关联成功"));
        this.getTree();
      }
    },
    /*
     * 获取对应的数据（角色）
     */
    getTreeData(rowItem) {
      let treeData = this.retVal.downstreamRoles;

      // 深拷贝，断开原先的数据的联系，并处理树形数据
      treeData = JSON.parse(JSON.stringify(treeData));
      let change = (arr, level = 1, unitCode = "") => {
        arr.forEach(v => {
          // 设置层级
          v.level = level;
          // 详细设置
          v.title = v.name || v.unitName;
          v.expand = true;
          v.code = v.downstreamRoleCode || v.unitCode;
          // 不可编辑设置
          if (v.level !== 3) {
            v.disabled = true;
          }
          if (unitCode) {
            v.unitCode = unitCode;
          }

          // 如果已存在关联角色则默认勾选
          let roles = [];
          rowItem.downstreamRoles.forEach(v => {
            roles = [...roles, ...v.roles.map(r => r.key)];
          });
          if (v.level === 3 && !rowItem.noBind && roles.some(r => r === v.key)) {
            v.webChecked = true;
          } else {
            v.webChecked = false;
          }
          if (!v.children) {
            v.children = v.roles;
          }
          let children = v.children;
          if (children && children.length > 0) {
            change(children, level + 1, v.unitCode);
          }
        });
      };
      change(treeData);
      return treeData;
    },
    /*
     * 打开映射弹窗
     */
    onOpenBind(item) {
      let treeData = this.getTreeData(item);
      this.$refs.AppDetailPointModal.open(treeData, item);
    },
    /*
     * 关联
     */
    onSubmitBind(data, rowItem) {
      this.orgSubmit(data, rowItem);
    },
    /*
     * 角色提交
     */
    async orgSubmit(data, rowItem) {
      let arr = data.length > 0 ? data : [{}];
      let params = {
        upstream: this._upstream,
        downstream: this._downstream,
        upstreamRoleId: rowItem.upstreamRoleId,
        mappings: arr.map(v => {
          return {
            unitCode: v.unitCode || "",
            downstreamRoleKey: v.key || "",
            downstreamRoleCode: v.downstreamRoleCode || "",
            downstreamRoleName: v.name || ""
          };
        })
      };
      this.$refs.AppDetailPointModal.setLoading(true);
      let res = await saveRoleMappings(params);
      this.$refs.AppDetailPointModal.setLoading(false);
      if (res.data && res.data.result == 0) {
        if (data.length > 0) {
          this.$Message.success($t("at3ogg4", "关联成功"));
        } else {
          this.$Message.success($t("jk1gy76", "解除关联成功"));
        }
        this.getTree();
        this.$refs.AppDetailPointModal.close();
      }
    },
    /*
     * 选择应用
     */
    onSelectMenu(name) {
      this.activeValue = name;
      this.getTree();
    }
  }
};